import { createAction } from '@reduxjs/toolkit'

import { VariantOption } from 'types/GlobalVariantOption'

// tryCreateVariantOptionBy
export const create = createAction('create_variant_option')
export const createSuccess = createAction<VariantOption>(
  'create_variant_option_success'
)
export const createFailed = createAction('create_variant_option_failed')

// tryUpdateVariantOptionBy
export const update = createAction('update_variant_option')
export const updateSuccess = createAction<VariantOption>(
  'update_variant_option_success'
)
export const updateFailed = createAction('update_variant_option_failed')

// tryDeleteVariantOptionBy
export const destroy = createAction('delete_variant_option')
export const destroySuccess = createAction<{
  id: string
  widgetId: string
}>('delete_variant_option_success')
export const destroyFailed = createAction('delete_variant_option_failed')
